module.exports = __webpack_public_path__ + "img/sanda-1.9d63d8ce.png";